export { FinancialPage as default } from '@/components/enpages/Ir/Financial'
